
import { defineComponent } from 'vue'

import progressItem from "./progress-item.vue"

export default defineComponent({
  props: {
    progressInfoList: Array,
    acceptSite: String,
    appId: String,
  },
  components: {
    progressItem,
  }
})
